<template>
<div class=corporation_common>
  <corporationCommonList></corporationCommonList>
</div>
</template>

<script>
import corporationCommonList from './corporationCommonList.vue'

export default {
  components: {
    corporationCommonList
  }
}
</script>
<style scoped>
.corporations {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/corporationCommonView/corporationCommon.vue